function checkWPAdminBar(){
    // Fix issue between wp admin bar and header overlapping
    if($("#wpadminbar").length && $(window).width() > 425){
        if ($("header").hasClass("has-fixed")){
            $("header.has-fixed").find(".header-main").addClass("wpadminbar-exists");
            return;
        }else{
            $("header").find(".header-main").removeClass("wpadminbar-exists");
        }
    }
}

export {checkWPAdminBar};